import { render, staticRenderFns } from "./settings-menu.vue?vue&type=template&id=0ca2e0fe&scoped=true&"
import script from "./settings-menu.vue?vue&type=script&lang=js&"
export * from "./settings-menu.vue?vue&type=script&lang=js&"
import style0 from "./settings-menu.vue?vue&type=style&index=0&id=0ca2e0fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca2e0fe",
  null
  
)

export default component.exports